import type { Path } from './resolvePath';

interface WalkOptions {
  skipPrimitives: boolean;
}

export function walkObjectDeeply(
  obj: unknown,
  callback: (value: unknown, path: Path) => void,
  options: WalkOptions = {
    skipPrimitives: false,
  },
  path: Path = [],
): void {
  const { skipPrimitives } = options;

  if (Array.isArray(obj)) {
    obj.forEach((v, i) => walkObjectDeeply(v, callback, options, [...path, i]));
    callback(obj, path);
  }

  if (typeof obj === 'object' && obj !== null) {
    Object.entries(obj).forEach(([k, v]) =>
      walkObjectDeeply(v, callback, options, [...path, k]),
    );
    callback(obj, path);
  }

  if (skipPrimitives) {
    return;
  }

  callback(obj, path);
}
